import { useLang } from "../lib/i18n";

export const Marquee = () => {
  const { t, sectorName } = useLang();
  const SECTORS = [
    "Real Estate", "Private Office", "Legal Services", "Healthcare", "Hospitality",
    "Logistics", "Construction", "Education", "Finance", "Retail", "Manufacturing",
    "Automotive", "Wellness", "Events", "Recruitment", "Insurance", "Agriculture",
    "Media", "Nonprofit", "Consulting"
  ];
  const items = [...t("marquee.extra"), ...SECTORS.map(sectorName)];
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="bg-green border-y border-gold/30 py-5 overflow-hidden" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-display italic text-cream/70 text-lg md:text-xl tracking-[0.15em]">
            <span className="px-6">{item}</span>
            <span className="text-gold text-xs">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
